// extracted by mini-css-extract-plugin
export var body = "_j7-0";
export var sectionHeader = "_j7-4";
export var shortcutColumns = "_j7-2";
export var shortcutList = "_j7-1";
export var shortcutSection = "_j7-3";